import React from "react";
import { WEBSITE_BUILDER_Z_LAYERS } from "../../../../utility/websiteBuilderZLayers";
import { IWebsiteBuilderSectionEntityViewBoundingBox } from "../../hooks/sectionEntity/helpers/sectionEntityViewBoundingBox";
import { TSectionEntityFrameHighlight } from "./SectionEntityFrame";
import classNames from "classnames";

interface ISectionEntityFrameHighlightProps {
  highlight: TSectionEntityFrameHighlight;
  boundingBox: IWebsiteBuilderSectionEntityViewBoundingBox;
}

export function SectionEntityFrameHighlight(props: ISectionEntityFrameHighlightProps) {
  const { highlight, boundingBox } = props;

  return (
    <>
      {highlight !== "none" && (
        <div
          className={
            classNames("website-builder-section-entity-frame-highlight", {
              "frame-highlight-weak": highlight === "weak",
              "frame-highlight-strong": highlight === "strong",
            })
          }
          style={{
            left: boundingBox.x,
            top: boundingBox.y,
            width: boundingBox.width,
            height: boundingBox.height,
            zIndex: WEBSITE_BUILDER_Z_LAYERS.designSpace.sectionEntityFrame,
          }}
        />
      )}
    </>
  );
}
